import React from "react";
import { Div, Text } from "atomize";

const HomeBrandsFooter = () => {
  return (
    <Div
      bg="black800"
      border={{ t: "1px solid" }}
      borderColor="black600"
      p={{ xs: "12px", lg: "12px 42px" }}
    >
      <Div
        d="flex"
        align="center"
        justify={{ xs: "space-between", md: "left" }}
        //maxW={{ lg: "60%" }}
      >
        <Text
          d={{ xs: "none", md: "inline-block" }}
          fontFamily="secondary"
          textWeight="bold"
          m={{ r: { xs: "", md: "29px" } }}
          style={{ lineHeight: "17px" }}
          //flexGrow="1 1 60%"
        >
          As seen on:
        </Text>
        <Div
          d="inline-block"
          bgImg="../../images/app-store.png"
          p={{ b: { xs: "19px", md: "22px" } }}
          m={{ r: { xs: "22px", md: "27px" } }}
          bgPos="center"
          bgSize="contain"
          bgRepeat="no-repeat"
          w="100%"
          maxW="72px"
        />
        <Div
          d="inline-block"
          bgImg="../../images/fb-marketing.png"
          p={{ b: "22px" }}
          m={{ r: { xs: "1rem", md: "27px" }, y: "auto" }}
          bgPos="center"
          bgSize="contain"
          bgRepeat="no-repeat"
          maxH="22px"
          w="100%"
          maxW="90px"
        />
        <Div
          d={{ xs: "none", md: "inline-block" }}
          bgImg="../../images/brew.png"
          p={{ b: "17px" }}
          m={{ r: { xs: "1rem", md: "27px" }, y: "auto" }}
          bgPos="center"
          bgSize="contain"
          bgRepeat="no-repeat"
          maxH="17px"
          w="100%"
          maxW="100px"
        />
        <Div
          d="inline-block"
          bgImg="../../images/G2.png"
          p={{ b: "20px" }}
          m={{ r: { xs: "1rem", md: "23px" } }}
          bgPos="center"
          bgSize="contain"
          bgRepeat="no-repeat"
          w="100%"
          maxW="125px"
        />
        <Div
          d="inline-block"
          bgImg="../../images/thehustle.png"
          p={{ b: "15px" }}
          //h="20px"
          bgPos="center"
          bgSize="contain"
          bgRepeat="no-repeat"
          w="100%"
          maxH="15px"
          //m="auto"
          maxW="66px"
        />
      </Div>
    </Div>
  );
};

export default HomeBrandsFooter;
